/* LEGAL-NOTICE
   © Copyright 2018 - Quid Informatica S.p.A. - All Rights Reserved
   https://quidinfo.it/qinetic/licence.html - "Quid Consumer Lending Platform"
   Deposito SIAE n. 012702 del 26 Luglio 2018
LEGAL-NOTICE */
import { ApiResParserCustomService } from './custom/services/api-res-parser/api-res-parser-custom.service';
import { ApiResParserService } from '@api/services/api-res-parser/api-res-parser.service';
import { AuthInterceptorService } from '@core/interceptors/auth-interceptor/auth-interceptor.service';
import { HttpErrorInterceptorService } from '@core/interceptors/http-error-interceptor/http-error-interceptor.service';
import { TranslateModule } from '@ngx-translate/core';
import { ApiModule } from '@core/modules/api/api.module';
import { LOCALE_ID, NgModule } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localeIt from '@angular/common/locales/it';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { IonicStorageModule } from '@ionic/storage-angular';
import { ServiceWorkerModule } from '@angular/service-worker';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { environment } from '../environments/environment';
import { APP_CONFIG } from './custom/config/app-config';
import { ROUTES_ACTIVATION } from './custom/config/routes-activation';
import { STEPS_CONFIG } from '@core/config/steps-config';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { HttpInterceptorService } from '@core/interceptors/http-interceptor/http-interceptor.service';

registerLocaleData(localeIt);

@NgModule({
  declarations: [AppComponent],
  entryComponents: [],
  imports: [
    BrowserModule,
    IonicModule.forRoot({ mode: 'md' }),
    IonicStorageModule.forRoot({ name: '__qindb' }),
    AppRoutingModule,
    ApiModule,
    TranslateModule.forRoot({
      defaultLanguage: 'it'
    }),
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production,
      registrationStrategy: 'registerWhenStable:30000'
    })
  ],
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    { provide: LOCALE_ID, useValue: 'it-IT' },
    { provide: 'APP_CONFIG', useValue: APP_CONFIG },
    { provide: 'STEPS_CONFIG', useValue: STEPS_CONFIG },
    { provide: 'ROUTES_ACTIVATION', useValue: ROUTES_ACTIVATION },
    {
      provide: ApiResParserService,
      useClass: ApiResParserCustomService
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpInterceptorService,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptorService,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpErrorInterceptorService,
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
